import React from "react";

import styles from "./DocumentItem.module.css";

const DocumentItem = (props) => {
  return (
    <div
      className={
        props.selectedDocument.document_filename ===
        props.document.document_filename
          ? `${styles.DocumentItem__Container__Selected}`
          : `${styles.DocumentItem__Container}`
      }
      onClick={() => props.onSelectDocument(props.document)}
    >
      <h4>{props.document.document_filename}</h4>
    </div>
  );
};

export default DocumentItem;
